/**
 * How stale the hCaptcha token can be before we refetch it on the frontend.
 */ export var HCAPTCHA_TOKEN_MAX_STALENESS_SECONDS = 'HCAPTCHA_TOKEN_MAX_STALENESS_SECONDS';
